import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type EmailTemplate = {
  email_template_id?: number; // 이메일 템플릿 idx
  email_template?: { [key: string]: Record<string, any> }; // 템플릿 내용
  type?: string; // 타입
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] EmailTemplate
   * --
   */
  getEmailTemplates: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_EMAIL_TEMPLATE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] EmailTemplate
   * --
   */
  getEmailTemplate: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_EMAIL_TEMPLATE, {
        email_template_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] EmailTemplate
   * --
   */
  createEmailTemplate: async (body: EmailTemplate) => {
    try {
      const res = await $http.post(APIConstant.CREATE_EMAIL_TEMPLATE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] EmailTemplate
   * --
   */
  updateEmailTemplate: async (body: EmailTemplate) => {
    try {
      const { email_template_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_EMAIL_TEMPLATE, {
        email_template_id: email_template_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] EmailTemplate
   * --
   */
  deleteEmailTemplate: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_EMAIL_TEMPLATE, {
        email_template_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
